(function(){
  function fixSpacing(){
    var ids = ['carousel_piedra','carousel_porcelanico','rich_text_xmrMRe'];
    ids.forEach(function(id){
      var sec = document.getElementById('shopify-section-'+id);
      if(!sec) return;
      sec.style.setProperty('--section-padding-top','8px');
      sec.style.setProperty('--section-padding-bottom','8px');
      sec.style.setProperty('--sm-section-padding-top','8px');
      sec.style.setProperty('--sm-section-padding-bottom','8px');
      sec.querySelectorAll('*').forEach(function(el){
        var cs = getComputedStyle(el);
        var pt = parseFloat(cs.paddingTop);
        var pb = parseFloat(cs.paddingBottom);
        if(pt > 20) el.style.setProperty('padding-top','8px','important');
        if(pb > 20) el.style.setProperty('padding-bottom','8px','important');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', fixSpacing);
  window.addEventListener('load', fixSpacing);
  setTimeout(fixSpacing, 800);
})();

// Meta Pixel - WhatsApp tracking
document.addEventListener('DOMContentLoaded', function() {
  var wa = document.getElementById('whatsapp-link') || document.getElementById('chat-bubble');
  if (wa) {
    wa.addEventListener('click', function() {
      if (typeof fbq !== 'undefined') fbq('track', 'Contact');
    });
  }
});

// Disable product links on home page, marmol and porcelanicos collection pages
(function() {
  var path = window.location.pathname;
  var blocked = ['/', '/collections/marmol', '/collections/porcelanicos'];
  var isBlocked = blocked.some(function(c) {
    return path === c || path.indexOf(c + '/') === 0 || path.indexOf(c + '?') === 0;
  });
  if (!isBlocked) return;

  // Block clicks at capture phase
  document.addEventListener('click', function(e) {
    var link = e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (link) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Remove pointer cursor from product links
  function disableLinks() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function(a) {
      a.style.cursor = 'default';
      a.style.pointerEvents = 'none';
    });
  }
  document.addEventListener('DOMContentLoaded', disableLinks);
  window.addEventListener('load', disableLinks);
  setTimeout(disableLinks, 800);
})();
